import AuthGate from "../components/AuthGate";

export default function Home() {
  return <AuthGate />;
}





// import React, { useEffect, useState, useRef } from "react";
// import { Link, useLocation } from "react-router-dom";
// import axios from "axios";
// import Banner from "../../img/banner.png";
// import streenTheme from "../../theme";

// import StoryImage from "../../components/StoryImage";

// //import { Layout, Space, Divider, Image } from "antd";
// import { Layout, Image, Button, List, Menu } from "antd";
// import {unloadUnityWebGL, unityContext} from "../../context/unityContext";
// const { Header, Sider, Content } = Layout;
// const Home = () => {
//   const [stories, setStories] = useState([]);
//   const scrollContainerRef = useRef(null); // Reference for the scrollable container
//   const cat = useLocation().search;
//   // console.log("cat", cat);
//   useEffect(() => {
//     if (unityContext) unloadUnityWebGL();
//     const fetchData = async () => {
//       try {
//         const res = await axios.get(`/api/stories${cat}`);
//         setStories(res.data);
//       } catch (err) {
//         console.log(err);
//       }
//     };
//     fetchData();
//   }, [cat]);
  
//   const getText = (html) => {
//     const doc = new DOMParser().parseFromString(html, "text/html");
//     return doc.body.textContent;
//   };

//   // Scroll left
//   const scrollLeft = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({
//         left: -300, // Adjust the scroll amount
//         behavior: "smooth",
//       });
//     }
//   };

//   // Scroll right
//   const scrollRight = () => {
//     if (scrollContainerRef.current) {
//       scrollContainerRef.current.scrollBy({
//         left: 300, // Adjust the scroll amount
//         behavior: "smooth",
//       });
//     }
//   };

//   const items = [
//     {
//       key: "1",
//       label: (
//         <Link
//           className="link"
//           to="/?cat=Fables"
//           style={{ lineHeight: "1.5", fontSize: "12px", fontWeight: "700" }}
//         >
//           FABLES
//         </Link>
//       ),
//     },
//     {
//       key: "2",
//       label: (
//         <Link
//           className="link"
//           to="/?cat=Fairytales"
//           style={{ lineHeight: "1.5", fontSize: "12px", fontWeight: "700" }}
//         >
//           MÄRCHEN
//           {/* Fairytales */}
//         </Link>
//       ),
//     },
//     {
//       key: "3",
//       label: (
//         <Link
//           className="link"
//           to="/?cat=Legends"
//           style={{ lineHeight: "1.5", fontSize: "12px", fontWeight: "700" }}
//         >
//           LEGENDEN
//           {/* Legends */}
//         </Link>
//       ),
//     },
//     {
//       key: "4",
//       label: (
//         <Link
//           className="link"
//           to="/?cat=Jokes"
//           style={{ lineHeight: "1.5", fontSize: "12px", fontWeight: "700" }}
//         >
//           SCHERZE
//           {/* Jokes */}
//         </Link>
//       ),
//     },
//     {
//       key: "sub1",
//       label: (
//         <Link
//           className="link"
//           to="/?cat=Scripts"
//           style={{ lineHeight: "1.5", fontSize: "12px", fontWeight: "700" }}
//         >
//           SKRIPTEN
//           {/* Scripts */}
//         </Link>
//       ),
//     },
//     {
//       key: "sub2",
//       //icon: <PieChartOutlined/>,
//       label: (
//         <Link
//           className="link"
//           to="/?cat=Poetry"
//           style={{ lineHeight: "1.5", fontSize: "12px", fontWeight: "bold" }}
//         >
//           POESIE
//           {/* Poetry */}
//         </Link>
//       ),
//     },
//   ];
//   // #endregion Menu Item Props

//   // #region User Profile Menu
//   const handleMenuClick = (e) => {
//     if (e.key === "logout") {
//       // Handle logout logic here
//       console.log("User clicked Menu");
//     }
//   };

//   const onClick = (e) => {
//     console.log("click ", e);
//   };

//   const userProfileMenu = <Menu onClick={handleMenuClick}></Menu>;

//   return (
//     <Layout className="home">
//       {/* BANNER SECTION */}
//       <Layout className="hero-banner">
//         <Content className="banner-content">
//           <div className="banner-text">
//             <h1>
//               Erwecke deine Geschichten mit{" "}
//               <div class="rainbow-text">
//                 {" "}
//                 <span>S</span>
//                 <span>T</span>
//                 <span>R</span>
//                 <span>E</span>
//                 <span>E</span>
//                 <span>N</span>{" "}
//               </div>{" "}
//               zum Leben!
//             </h1>
//             <p>Mit STREEN kannst du</p>
//             <ul>
//               <li>Spannende Geschichten gemeinsam lesen</li>
//               <li>Coole digitale Effekte erstellen</li>
//               <li>
//                 Eure Effekte abspielen, während du deine Geschichten laut
//                 vorliest
//               </li>
//             </ul>
//             {/*  <div className="banner-buttons">
//                 <Link to="https://streen.ais-lab.eu/">
//                  //</Link><Link to="/about"> 
//                   <Button type="primary" size="large" className="btn" >Mehr erfahren</Button>
//                 </Link>                
//               </div> */}
//           </div>
//           <div className="banner-image">
//             <img src={Banner} alt="Reading books" />
//           </div>
//         </Content>
//       </Layout>

//       {/* STORIES SECTION */}
//       <Layout className="stories">
//         <h2 className="section-title">Entdecken Sie unsere Geschichten</h2>
//         <div className="scroll-container">
//           <Button className="scroll-button left" onClick={scrollLeft}>
//             &#8592; {/* Left arrow */}
//           </Button>

//           <div ref={scrollContainerRef} className="story-list">
//             <List
//               dataSource={stories}
//               renderItem={(story) => (
//                 <List.Item key={story.id} className="story-item">
//                   <Content className="story">
//                     <div className="img">
                     
//                       <StoryImage
//                   filename={story?.img}
//                   name={story?.name}
//                 />
//                     </div>
//                     <div className="content">
//                       <h1>{story.title}</h1>
//                       <p>{getText(story.desc)}</p>
//                       <Link className="link" to={`/story/${story.id}`}>
//                         <Button type="primary" size="large" className="btn">
//                           Mehr erfahren
//                         </Button>
//                       </Link>
//                     </div>
//                   </Content>
//                 </List.Item>
//               )}
//             />
//           </div>

//           <Button className="scroll-button right" onClick={scrollRight}>
//             &#8594; {/* Right arrow */}
//           </Button>
//         </div>
//       </Layout>

//       <Content
//         direction="horizontal"
//         size="middle"
//         className="foot-menu-container"
//       >
//         <Menu
//           className="foot-menu"
//           onClick={onClick}
//           //defaultSelectedKeys={['1']}
//           // defaultOpenKeys={['sub1']}
//           mode="horizontal"
//           items={items}
//           // inlineCollapsed={collapsed}
//         />
//       </Content>
//     </Layout>
//   );
// };

// export default Home;
